import { useEffect, useRef, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { creaNuevoCab, creaNuevoDet,
     creaNuevoTipo, getAllConfigTipo, getConfigCabByTipo, getConfigDetByCab,
      modificaDet, 
      eliminaDet
    } from '../../services/Roles/RolesService';
import CreaTipo from './CreaTipo';
import CreaCab from './CreaCab';
import CreaDet from './CreaDet';
import { InputText } from 'primereact/inputtext';

const ConfiguraDet = () => {
    const [tipo, setTipo] = useState({});
    const [lstTipos, setLstTipos] = useState([]);
    const [cargaTipo, setCargaTipo] = useState(false);

    const [cabecera, setCabecera] = useState({});
    const [lstCabeceras, setLstCabeceras] = useState([]);
    const [cargaCabecera, setCargaCabecera] = useState(false);

    const [detalle, setDetalle] = useState({});
    const [lstDetalles, setLstDetalles] = useState([]);
    const [cargaDetalle, setCargaDetalle] = useState(false);

    const [cambioTipo, setCambioTipo] = useState(true);
    const [cambioCab, setCambioCab] = useState(true);
    const [cambioDet, setCambioDet] = useState(true);

    const [visibleTipo, setVisibleTipo] = useState(false);
    const [visibleCab, setVisibleCab] = useState(false);
    const [visibleDet, setVisibleDet] = useState(false);

    const miToast = useRef();

    useEffect(() => {
        const recuperaTipo = async () => {
            try {
                setCargaTipo(true);
                const tiposTmp = await getAllConfigTipo();
                const tiposTmp2 = tiposTmp.map((item) => ({
                    ...item,
                    campoBusqueda: `${item.codigo} - ${item.nombre}`
                }));
                //console.log(tiposTmp2);
                setLstTipos(tiposTmp2);
            } catch (err) {
                console.error('ERROR: ', err.message);
            } finally {
                setCargaTipo(false);
            }
        };
        recuperaTipo();
    }, [cambioTipo]);

    useEffect(() => {
        const recuperaCabecera = async (tipoId) => {
            try {
                setCargaCabecera(true);
                const cabecerasTmp = await getConfigCabByTipo(tipoId);
                const cabecerasTmp2 = cabecerasTmp.map((item) => ({
                    ...item,
                    campoBusqueda: `${item.codigo}-${item.nombre}`
                }));
                setLstCabeceras(cabecerasTmp2);
            } catch (err) {
                console.error('ERROR: ', err.message);
            } finally {
                setCargaCabecera(false);
            }
        };
        if (tipo?.configuracionTipoId) {
            recuperaCabecera(tipo.configuracionTipoId);
        }
    }, [tipo, cambioCab]);

    useEffect(() => {
        //
        const recuperaDetalles = async (configuraCabId) => {
            try {
                setCargaDetalle(true);
                const detallesTmp = await getConfigDetByCab(configuraCabId);
                //console.log('HH0=', detallesTmp);
                setLstDetalles(detallesTmp);
            } catch (err) {
                console.error('ERROR: ', err.message);
            } finally {
                setCargaDetalle(false);
            }
        };
        if (cabecera.configuracionCabId) {
            recuperaDetalles(cabecera.configuracionCabId);
        }
    }, [cabecera, cambioDet]);

    const tipoNombreTemplate = (item) => {
        if (!item) {
            return <span>Selecciona un Tipo Configuracion</span>;
        }
        return (
            <div>
                {item.codigo}-{item.nombre}{' '}
            </div>
        );
    };

    const cabeceraNombreTemplate = (item) => {
        if (!item) {
            return <span>Selecciona un Tipo Configuracion</span>;
        }
        return (
            <div>
                {item.codigo}-{item.nombre}{' '}
            </div>
        );
    };

    const handleEdit = (fila) => {
        //console.log('QQ0=', fila);
        setDetalle(fila);
        setVisibleDet(true);
    };
    const handleDelete = async (rowData) => {
        if (!window.confirm(`¿Eliminar ${rowData.nombre}?`)) return;

        try {
            await eliminaDet(rowData.configuracionDetId); // <--- Llamada al servicio
            miToast.current.show({ severity: 'success', summary: 'Eliminado', detail: 'Registro eliminado' });
            setCambioDet(!cambioDet); // <--- Esto recarga la tabla
        } catch (err) {
            console.error(err);
            miToast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo eliminar' });
        }
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-info" tooltip="Editar" onClick={() => handleEdit(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" tooltip="Borrar" onClick={() => handleDelete(rowData)} />
            </div>
        );
    };

    const handleChangeTipo = (evt) => {
        setTipo(evt.value);
        setCabecera({});
        setLstCabeceras([]);
        setDetalle({});
        setLstDetalles([]);
    };

    const handleChangeCab = (evt) => {
        setCabecera(evt.value);
        setDetalle({});
        setLstDetalles([]);
    };

    const abreAdiTipo = () => {
        setVisibleTipo(true);
    };

    const guardaTipo = async (formData) => {
        const objPost = {
            codigo: formData.codigo,
            nombre: formData.descripcion,
            estado: 'Activo',
            activo: true
        };
        try {
            const guardado = await creaNuevoTipo(objPost);
            miToast.current.show({ severity: 'success', summary: 'Exito', detail: 'Nuevo Tipo Creado' });
            setTipo({});
            setLstTipos([]);
            setCabecera({});
            setLstCabeceras([]);
            setDetalle({});
            setLstDetalles([]);
            setCambioTipo((prev) => !prev);
        } catch (err) {
            console.error('ERROR: al guardar', err.message);
            miToast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al crear nuevo Tipo' });
        } finally {
            setVisibleTipo(false);
        }
    };

    const abreAdiCab = () => {
        if (!tipo?.configuracionTipoId) {
            miToast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe Seleccionar Tipo' });
            return;
        }

        setVisibleCab(true);
    };

    const guardaCab = async (formData) => {
        if (!tipo?.configuracionTipoId) {
            miToast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe Seleccionar Tipo' });
            return;
        }
        const objPost = {
            configuracionTipoId: tipo.configuracionTipoId,
            codigo: formData.codigo,
            nombre: formData.nombre,
            parametro: formData.parametro,
            estado: 'Activo',
            activo: true
        };
        try {
            const guardado = await creaNuevoCab(objPost);
            miToast.current.show({ severity: 'success', summary: 'Exito', detail: 'Nueva Cabecera creada' });
            setCabecera({});
            setLstCabeceras([]);
            setDetalle({});
            setLstDetalles([]);
            setCambioCab((prev) => !prev);
        } catch (err) {
            console.error('Error: ', err.message);
            miToast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al crear la Cabecera' });
        } finally {
            setVisibleCab(false);
        }
    };

    const abreAdiDet = () => {
        if (!tipo?.configuracionTipoId) {
            miToast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe Seleccionar Tipo' });
            return;
        }
        if (!cabecera?.configuracionCabId) {
            miToast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe Seleccionar Cabecera' });
            return;
        }
        setDetalle({});
        setVisibleDet(true);
    };

    const guardaDet = async (formData) => {
        if (!tipo?.configuracionTipoId) {
            miToast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe Seleccionar Tipo' });
            return;
        }
        if (!cabecera?.configuracionCabId) {
            miToast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe Seleccionar Cabecera' });
            return;
        }
        if (formData.detalleId === 0) {
            // Creacion
            const objPost = {
                padreConfiguracionDetId: 0,
                configuracionCabId: cabecera?.configuracionCabId,
                codigo: formData.codigo,
                nombre: formData.nombre,
                parametro: formData.parametro,
                estado: 'Activo',
                activo: formData.activo
            };
            try {
                const guardado = await creaNuevoDet(objPost);
                miToast.current.show({ severity: 'success', summary: 'Exito', detail: 'Nuevo Detalle Creado' });
                setDetalle({});
                setLstDetalles([]);
                setCambioDet((prev) => !prev);
            } catch (err) {
                console.error('Error: ', err.message);
                miToast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al crear Detalle' });
            } finally {
                setVisibleDet(false);
            }
        } else {
            // Modificacion
            const objPost = {
                configuracionDetId: formData.detalleId,
                padreConfiguracionDetId: 0,
                configuracionCabId: cabecera?.configuracionCabId,
                codigo: formData.codigo,
                nombre: formData.nombre,
                parametro: formData.parametro,
                estado: 'Activo',
                activo: formData.activo
            };
            try {
                const guardado = await modificaDet(objPost);
                miToast.current.show({ severity: 'success', summary: 'Exito', detail: 'Modificacion realizada' });
                setDetalle({});
                setLstDetalles([]);
                setCambioDet((prev) => !prev);
            } catch (err) {
                console.error('Error: ', err.message);
                miToast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al Modificar Detalle' });
            } finally {
                setVisibleDet(false);
            }
        }
    };

    // filtro
    const [filtros, setFiltros] = useState({
        global: { value: null, matchMode: 'contains' },
        codigo: { value: null, matchMode: 'contains' },
        nombre: { value: null, matchMode: 'contains' }
    });

    const [valoresFiltros, setValoresFiltros] = useState({
        nombre: '',
        codigo: '',
        global: ''
    });
    
    const textoFilterTemplate = (options, field) => {
        return (
            <InputText
                value={valoresFiltros[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltros((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtros };
                        newFilters[field].value = nuevoValor;
                        setFiltros(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtro ${field}`}
                className="w-full"
            />
        );
    };

    return (
        <div className="card">
            <h5>Componente de configuracion</h5>
            <Toast ref={miToast} />
            <Dialog header="Nuevo Tipo" visible={visibleTipo} style={{ width: '50vw' }} onHide={() => setVisibleTipo(false)}>
                <CreaTipo onGuardar={guardaTipo} />
            </Dialog>
            <Dialog header="Nueva Cabecera" visible={visibleCab} style={{ width: '50vw' }} onHide={() => setVisibleCab(false)}>
                <CreaCab tipo={tipo} onGuardar={guardaCab} />
            </Dialog>
            <Dialog header="Nuevo Detalle" visible={visibleDet} style={{ width: '50vw' }} onHide={() => setVisibleDet(false)}>
                <CreaDet cabecera={cabecera} onGuardar={guardaDet} detalle={detalle} />
            </Dialog>
            <div className="formgrid grid p-fluid mb-3">
                {/* Columna 1 */}
                <div className="field col-12 md:col-4">
                    <div className="formgrid grid p-fluid">
                        {/* Tipo */}
                        <div className="field col-12 md:col-10">
                            <label htmlFor="cboTipo">Tipo: </label>
                            {cargaTipo ? (
                                <div className="flex align-items-center">
                                    <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                                </div>
                            ) : (
                                <Dropdown
                                    inputId="cboTipo"
                                    value={tipo}
                                    onChange={handleChangeTipo}
                                    options={lstTipos}
                                    placeholder="Selecciona un Tipo"
                                    itemTemplate={tipoNombreTemplate}
                                    filter
                                    filterBy="campoBusqueda"
                                    showClear
                                    optionLabel="campoBusqueda"
                                />
                            )}
                        </div>
                        <div className="field col-12 md:col-2 flex align-items-end">
                            <Button label="+" onClick={abreAdiTipo} tooltip="Adicionar Nuevo Tipo" />
                        </div>
                        {/* Cabecera */}
                        <div className="field col-12 md:col-10">
                            <label htmlFor="cboCabecera">Cabecera: </label>
                            {cargaCabecera ? (
                                <div className="flex align-items-center">
                                    <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                                </div>
                            ) : (
                                <Dropdown
                                    inputId="cboCabecera"
                                    value={cabecera}
                                    onChange={handleChangeCab}
                                    options={lstCabeceras}
                                    placeholder="Selecciona una cabecera"
                                    itemTemplate={cabeceraNombreTemplate}
                                    filter
                                    filterBy="campoBusqueda"
                                    showClear
                                    optionLabel="campoBusqueda"
                                />
                            )}
                        </div>
                        <div className="field col-12 md:col-2 flex align-items-end">
                            <Button label="+" onClick={abreAdiCab} tooltip="Adicion Nueva Cabecera"/>
                        </div>
                    </div>
                </div>
                {/* Columna Division */}
                <div className="field col-12 md:col-1"></div>
                {/* Columna 2 */}
                <div className="field col-12 md:col-7">
                    <div className="formgrid grid p-fluid">
                        <div className="field col-12 md:col-8">
                            <h6>Datos del Detalle</h6>
                        </div>
                        <div className="field col-12 md:col-4">
                            <Button label="Nuevo Detalle" onClick={abreAdiDet} />
                        </div>
                        <div className="field col-12 md:col-12">
                            <DataTable value={lstDetalles} size="small" tableStyle={{ minWidth: '40rem' }} stripedRows 
                              paginator 
                              rows={5} 
                              rowsPerPageOptions={[5, 10, 25, 50]} 
                              loading={cargaDetalle}
                              dataKey='configuracionDetId'
                              filters={filtros}
                              filterDisplay="row"
                              emptyMessage="No se encontraron resultados."
                              scrollable
                            >
                                <Column header="Codigo" field="codigo" filter filterPlaceholder="Filtro Proyecto" filterElement={(options) => textoFilterTemplate(options, 'codigo')} showFilterMenu={false}/>
                                <Column header="Nombre" field="nombre" filter filterPlaceholder="Filtro Proyecto" filterElement={(options) => textoFilterTemplate(options, 'nombre')} showFilterMenu={false} />
                                <Column header="Acciones" body={actionBodyTemplate} style={{ minWidth: '8rem' }} />
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfiguraDet;
